module.exports = __webpack_public_path__ + "static/media/MH.aa0f484f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MH.svg
// module id = 2207
// module chunks = 7